import React from 'react';
import ReactTable from "react-table";

import "react-table/react-table.css";

import 'bootstrap/dist/css/bootstrap.css';




class NPReactTable extends React.Component {
    constructor(props) {
        super(props);  
        // this.propTypes={
        //     ...ReactTable.propTypes,
        // };
        this.state={selected:-1};        
        this.reactTable=null;
        this.getReactTable= this.getReactTable.bind(this);
        this.setTableText = this.setTableText.bind(this);
    }

    componentDidMount(){
        this.setTableText();
    }

    setTableText(){
        setTimeout(() => {
            var error = document.getElementsByClassName("error");
            if(error.length > 0){
                var tables = document.getElementsByClassName("rt-noData");
                if(tables){
                    Array.prototype.forEach.call(tables, function(el) {
                        if(el.parentElement.classList.contains('allocationTable')){
                            el.innerHTML = "Perform a search to load data";
                        }
                        else{
                            el.innerHTML = "Select a filter to start loading data"
                        }
                    });
                
                 }
                }
            var pendingTable = document.getElementById("pending-users");
            if(pendingTable){
                pendingTable = pendingTable.getElementsByClassName("rt-noData");
                Array.prototype.forEach.call(pendingTable, function(el) {
                    el.innerHTML = "No pending users";

                });
            
            }
            var tableText = document.querySelectorAll(".rt-noData");
            for (var i = 0; i < tableText.length; i++) {
                tableText[i].style.display = "block";
              }
          }, 2000)
 
       
    }

    getReactTable()
    {
        return this.reactTable;
    }

    render(){
        let self=this;
        const { headerZIndex, ...restProps } = this.props;
        const tableStyle = headerZIndex ? {
            ...restProps.style,
        } : restProps.style;
        
        const getTheadThProps = () => {
            return headerZIndex ? {
                style: {
                    zIndex: headerZIndex
                }
            } : {};
        };
        
        return <ReactTable ref={(r) => {this.reactTable = r}}  
            getTheadThProps={getTheadThProps}
            style={tableStyle}
            getTrProps={(state, rowInfo) => {
            return {
                onClick: (e, handleOriginal) => {
                    if (rowInfo && rowInfo.index>-1)
                    {
                        self.setState({ selected: rowInfo.index});
                    }
                    // IMPORTANT! React-Table uses onClick internally to trigger
                    // events like expanding SubComponents and pivots.
                    // By default a custom 'onClick' handler will override this functionality.
                    // If you want to fire the original onClick handler, call the
                    // 'handleOriginal' function.
                    if (handleOriginal) {
                      handleOriginal();
                    }
                },
                style: rowInfo ? {
                    background: rowInfo.index === self.state.selected ? 'lightgray' : 'white',
                    //color: rowInfo.index === self.state.selected ? 'white' : 'black'
                } : {}
            }
        }}{...restProps}/>}
}

NPReactTable.propTypes={
    ...ReactTable.propTypes,
};




  export default NPReactTable;